import React, { useEffect, useRef } from 'react';
import { AbilityUse } from '../utils/types';
import styles from './AbilityUsageMenu.module.css';

interface AbilityUsageMenuProps {
  abilityUsages: AbilityUse[];
  position: { x: number; y: number };
  onSelect: (timeSeconds: number) => void;
  onClose: () => void;
  agent: string;
  abilityIcon: string;
  abilityName: string;
  roundNumber: number;
}

const AbilityUsageMenu: React.FC<AbilityUsageMenuProps> = ({
  abilityUsages,
  position,
  onSelect,
  onClose,
  agent,
  abilityIcon,
  abilityName,
  roundNumber,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div 
      className={styles.menu} 
      style={{ left: position.x, top: position.y }}
      ref={menuRef}
    >
      <div className={styles.roundHeader}>
        Round #{roundNumber}
      </div>
      <div className={styles.menuHeader}>
        <img 
          src={`/agents/${agent.toLowerCase()}.png`}
          alt={agent}
          className={styles.agentIcon}
        />
        <img 
          src={abilityIcon}
          alt={abilityName}
          className={styles.abilityIcon}
        />
        <span className={styles.abilityName}>{abilityName}</span>
      </div>
      {abilityUsages.map((usage, index) => (
        <div
          key={index}
          className={styles.menuItem}
          onClick={() => onSelect(Math.floor(usage.timeSeconds) - 1.25)}
        >
          <i className="bi bi-stopwatch"></i>
          <span className={styles.timeText}>{formatRoundTime(usage.timeSeconds)}</span>
        </div>
      ))}
    </div>
  );
};

function formatRoundTime(seconds: number): string {
  if (seconds >= 100) return '0:00';
  const roundTime = 100 - Math.floor(seconds);
  const minutes = Math.floor(roundTime / 60);
  const remainingSeconds = roundTime % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

export default AbilityUsageMenu; 